import * as React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { Icon } from "antd";
import Report8Template from "./Report8Template";
import { IReport8ApplicantPresentationModel } from "../../../../presenter/report/model/Report8ApplicantPresentationModel";

const PDFExportReport8 = ({
  translate,
  data,
  title,
  subtitle,
  fileName
}: {
  translate?: any;
  data?: IReport8ApplicantPresentationModel[];
  title?: string;
  subtitle?: string;
  fileName: string;
}) => {
  return (
    <PDFDownloadLink
      document={
        <Report8Template
          translate={translate}
          data={data}
          title={title}
          subtitle={subtitle}
        />
      }
      fileName={fileName}
      style={{}}
    >
      {({ blob, url, loading, error }) =>
        loading ? (
          translate("reports.document.loading")
        ) : (
          <Icon
            type="file-pdf"
            theme={"outlined"}
            style={{ fontSize: 20, color: "#ED1C24" }}
          />
        )
      }
    </PDFDownloadLink>
  );
};

export default PDFExportReport8;
